import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/faturamento/contrato-modelo/v1`;
const pdfPath = process.env.REACT_APP_URL_API_DOC_HUB;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findContratoModelo({
  empresa_cnpj,
  id,
  include,
  page,
  where = {},
  orwhere = {},
  isSameOrWhere = false,
  orderByColumn,
}) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });

  let queryOrWhere = "";
  Object.keys(orwhere).forEach((key) => {
    queryOrWhere += `&orwhere${isSameOrWhere ? "[]" : ""}[${key}]=${
      orwhere[key]
    }`;
  });

  return search(
    `${path}${
      id ? `/${id}` : ""
    }?empresa_cnpj=${empresa_cnpj}${queryWhere}${queryOrWhere}${
      include ? `&include=${include}` : ""
    }${page ? `&page=${page}` : ""}${
      orderByColumn ? "&orderBy=" + orderByColumn : ""
    }`,
    "GET",
    headers
  );
}

export const searchByCompany = async ({ companyId, empresa_cnpj }) => {
  return search(
    `${path}/por-empresa/${companyId}?empresa_cnpj=${empresa_cnpj}`,
    "GET",
    headers
  );
};

export const createModeloContrato = async ({ body, empresa_cnpj }) =>
  search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);

export const updateModeloContrato = async ({ id, body, empresa_cnpj }) =>
  search(`${path}/${id}?empresa_cnpj=${empresa_cnpj}`, "PUT", headers, body);

export async function downloadPdf(body) {
  var header = new Headers();
  header.append("content-type", "application/json");
  return search(
    `${pdfPath}/generic/html-page/convert-pdf`,
    "POST",
    header,
    body
  );
}

export async function sendEmail({ body, empresa_cnpj }) {
  return search(
    `${path}/send-email?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export const deleteModeloContrato = async ({ id, empresa_cnpj }) =>
  search(`${path}/${id}?empresa_cnpj=${empresa_cnpj}`, "DELETE", headers);

export async function GetModel({
  empresa_cnpj,
  id,
  include,
  page,
  where = {},
  orwhere = {},
  isSameOrWhere = false,
  orderByColumn,
}) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });

  let queryOrWhere = "";
  Object.keys(orwhere).forEach((key) => {
    queryOrWhere += `&orwhere${isSameOrWhere ? "[]" : ""}[${key}]=${
      orwhere[key]
    }`;
  });

  return search(
    `${path}/modelo${
      id ? `/${id}` : ""
    }?empresa_cnpj=${empresa_cnpj}${queryWhere}${queryOrWhere}${
      include ? `&include=${include}` : ""
    }${page ? `&page=${page}` : ""}${
      orderByColumn ? "&orderBy=" + orderByColumn : ""
    }`,
    "GET",
    headers
  );
}
